import React from 'react';
import { LucideIcon } from 'lucide-react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  icon?: LucideIcon;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, icon: Icon }) => {
  return (
    <div className="mb-8">
      <div className="flex items-center gap-3 mb-1">
        {Icon && (
          <div className="p-2 bg-brand-cyan/10 rounded-lg">
            <Icon className="w-6 h-6 text-brand-cyan" />
          </div>
        )}
        <div>
          <h1 className="text-2xl md:text-3xl font-bold text-white leading-tight">{title}</h1>
          {subtitle && <p className="text-[#bbb] text-sm md:text-base mt-0.5">{subtitle}</p>}
        </div>
      </div>
    </div>
  );
};
